// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PushMessageSvg from '@rsuite/icon-font/lib/application/PushMessage';
var PushMessage = createSvgIcon({
  as: PushMessageSvg,
  ariaLabel: 'push message',
  category: 'application',
  displayName: 'PushMessage'
});
export default PushMessage;